// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__1uuun","upload":"Small_upload__2xAWG","imageWrap":"Small_imageWrap__3UPAU","removeBtn":"Small_removeBtn___4adB"};